<template>
  <div class="py-6 px-8">
    <h-header back="../service-providers">
      <template #actions>
        <v-btn
          @click="openLinkServiceProviderModal"
          color="primary"
          elevation="0"
        >
          <v-icon left>mdi-plus</v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t(`serviceProviders.action.link`) }}
          </span>
        </v-btn>
      </template>
    </h-header>

    <h-loading v-if="isServiceProviderLoading" />
    <div v-else>
      <ServiceProviderDetailsHeader :service-provider="serviceProvider" />
      <h4 class="mb-3 grey--text">{{ customerList }}</h4>
      <v-card elevation="0" outlined>
        <v-data-table
          :loading-text="$t('appointment.table.loading')"
          :no-data-text="$t('appointment.table.noData')"
          :items-per-page="itemsPerPage"
          :loading="isLoadingBoard"
          :headers="headers"
          :items="linkedCustomers"
          mobile-breakpoint="20"
          hide-default-footer
          disable-sort
        >
          <template v-slot:[`item.name`]="{ item }">
            {{ item.real_estate.name }}
          </template>
          <template v-slot:[`item.document`]="{ item }">
            {{ formatDocument(item.real_estate.cnpj) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <ServiceProviderCustomerListMenu @openUnlinkServiceProviderModal="openUnlinkServiceProviderModal" :item="item" />
          </template>
        </v-data-table>
      </v-card>
    </div>

    <ModalLinkServiceProviderCustomer :id="itemId" :customer="customer" :unlink="isUnlinking" />
  </div>
</template>

<script>
import ServiceProviderDetailsHeader from '../fragments/ServiceProviderDetailsHeader'
import ServiceProviderCustomerListMenu from '../fragments/ServiceProviderCustomerListMenu'
import ModalLinkServiceProviderCustomer from '@/components/customer/modals/ModalLinkServiceProviderCustomer'

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { serviceProviderCustomerHeaders } from '../listHeaders'
import { formatDocument } from '@/util/document'

export default {
  name: 'ServiceProviderDetails',

  components: {
    ServiceProviderDetailsHeader,
    ServiceProviderCustomerListMenu,
    ModalLinkServiceProviderCustomer,
  },

  computed: {
    ...mapGetters([
      'serviceProvider',
      'isLoading',
      'isLoadingBoard',
      'isServiceProviderLoading',
      'linkedCustomers',
      'itemsPerPage',
    ]),

    serviceProviderId() {
      return this.serviceProvider.id
    },
  },

  methods: {
    ...mapActions(['openModal', 'showServiceProvider', 'listLinkedCustomers']),
    ...mapMutations(['setFilters']),

    fetch() {
      this.showServiceProvider(this.$route.params.id)
        .then(() => this.setFilters({ serviceProviderId: this.serviceProviderId, active: true }))
        .then(() => this.listLinkedCustomers())
    },

    openUnlinkServiceProviderModal(item, isUnlinking) {
      const customer = item.real_estate
      this.itemId = item.id
      this.customer = customer
      this.isUnlinking = isUnlinking
      this.openModal('LINK_SERVICE_PROVIDER_CUSTOMER')
    },

    openLinkServiceProviderModal() {
      this.customer = null
      this.isUnlinking = false
      this.openModal('LINK_SERVICE_PROVIDER_CUSTOMER')
    },

    formatDocument,
  },

  data() {
    return {
      itemId: null,
      customer: {},
      isUnlinking: false,
      headers: serviceProviderCustomerHeaders,

      customerList: this.$t('pages.title.customerList'),
    }
  },

  mounted() {
    this.fetch()
  },
}
</script>
